import { createRoot } from "react-dom/client";

import "./styles/theme.css";

const rootElement = document.querySelector("#root");

if (rootElement === null) {
  throw new Error("Root element #root was not found.");
}

const root = createRoot(rootElement);

if (__SUPPORT_HUB_E2E__) {
  void import("./e2e/runtime").then(({ mountE2eApp }) => {
    mountE2eApp(root);
  });
} else {
  void import("./runtime").then(({ mountApp }) => {
    mountApp(root);
  });
}
